export const config = {
  env: "prod",
  apiUrl: "https://api.popopo.com",
  cdnUrl: "https://cdn-icon.popopo.com/",
  firebase: {
    apiKey: "AIzaSyCjExscTSzwfyC5OeeUAvsgp9CRdH4x-G8",
    authDomain: "popopo-prod.web.app",
    projectId: "popopo-prod",
    storageBucket: "popopo-prod.firebasestorage.app",
    messagingSenderId: "209007912111",
    appId: "1:209007912111:web:0561336742751fbc33e05a",
    measurementId: "G-2S0RCP5BTK"
  },
  tenantId: "tf-ops-pjoss",
  recaptchaSiteKey: "6LcRhnwsAAAAAGvoSo15ytMWFZg1g6kq4JYh8v4D",
  trtc: {
    appId: 1
  },
  appOpenUrl: "popopo://",
  applinkBaseUrl: "https://applink.popopo.com"
}
